import React from "react";
import { Paper, Table, TableBody, TableContainer } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeviceListItem from "./DeviceListItem";
import { IDevice } from "./types";
import FloatingActionButton from "../../Components/FloatingActionButton";

interface IDeviceListProps {
  devices: IDevice[];
}

const DeviceList = (props: IDeviceListProps) => {
  const { devices } = props;
  const navigate = useNavigate();
  const handleAddDevice = () => navigate("/devices/-1");
  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableBody>
            {devices
              .sort(function (a: IDevice, b: IDevice) {
                return a.name.localeCompare(b.name);
              })
              .map((device) => (
                <DeviceListItem key={device.id} device={device} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <FloatingActionButton
        iconName="plus"
        onClick={handleAddDevice}
        data-cy="device-add"
      />
    </>
  );
};

export default DeviceList;
